import { render, staticRenderFns } from "./TeamLeaderboardTable.vue?vue&type=template&id=5efe95a6&scoped=true&"
import script from "./TeamLeaderboardTable.vue?vue&type=script&lang=js&"
export * from "./TeamLeaderboardTable.vue?vue&type=script&lang=js&"
import style0 from "./TeamLeaderboardTable.vue?vue&type=style&index=0&id=5efe95a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe95a6",
  null
  
)

export default component.exports